// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__348J9","col":"styles_col__FhVty"};